import { useQuery } from "@tanstack/react-query";
import type { OnboardedResponse } from "../types.ts";
import { useApi } from "./use-api.ts";

/**
 * Hook to fetch onboarding status for the current organization.
 *
 * Returns:
 * - onboarded: true if org created before 2025-12-05 (release date) OR (app_configs > 0 AND tests > 0 AND discovery_runs > 0)
 * - data: counts of app_configs, tests, and discovery_runs
 */
export function useOnboarded() {
  const { callApi } = useApi<OnboardedResponse>();

  return useQuery({
    queryKey: ["onboarded"],
    queryFn: async () => callApi("/onboarding"),
    refetchInterval: 30_000, // Refetch every 30 seconds
  });
}
